import { moduleProviderFactory } from "core/providers";
import { 
	PatientsByCategoryReportList
 } from "application/patients-by-category-report/pages";

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: "master.app.main.patients-by-category-report",
				pattern: "/patients-by-category-report",
				children: [
					{
						name: "master.app.main.patients-by-category-report.list",
						pattern: "",
						tabTitle: 'MENU.PATIENTS_BY_CATEGORY_REPORTS_SUB',
						component: PatientsByCategoryReportList,
						authorization: "reportSection.read",
						data: {
							title: "MENU.PATIENTS_BY_CATEGORY_REPORTS_SUB",
						},
					}
				],
			},
		],
		menu : [
            {
                title: 'MENU.REPORTS',
                order: 9,
				icon: "table-view",
				authorization: "reportSection.read",
                subMenu: [
                    {
                        title: "MENU.PATIENTS_BY_CATEGORY_REPORTS_SUB",
						authorization: "coreUserSection.read",
						route: "master.app.main.patients-by-category-report.list",
						order: 2
                    }                    
                ]
            }
        ]
	});
})();
